import React from 'react';
import PropTypes from "prop-types";
import {Typography, withStyles} from "@material-ui/core";

const styles = theme => ({
  title: {},
});

let H3Title = props => {
  const { title, classes, style, color, noWrap, className, ...rest } = props;

  return (<Typography {...rest} noWrap={noWrap} variant="h3" color={color ? color : 'primary'} style={style} className={classes.title+(className ? " "+ className : "")}>
                  {title? title : props.children}
              </Typography>);
}

H3Title.propTypes = {
  title: PropTypes.any,
  color: PropTypes.string,
  style: PropTypes.object,
  noWrap: PropTypes.bool
};

export default withStyles(styles)(H3Title);
